import { DefaultPrimaryHeader, DescriptionSecondary, getFallbackHeaderLabel, HeaderBlock } from '../activityFeedHeaderShared';

function DefaultActivityHeader({ entity, item, activity }) {
  return (
    <HeaderBlock
      primary={
        <DefaultPrimaryHeader
          label={
            entity?.name ||
            entity?.componentName ||
            entity?.userName ||
            entity?.hash ||
            entity?.checkId ||
            entity?.groupId ||
            getFallbackHeaderLabel(item)
          }
          activity={activity}
        />
      }
      secondary={<DescriptionSecondary item={item} />}
    />
  );
}

export default DefaultActivityHeader;
